import type { AuthStatus as AuthStatusType } from '@/types/auth'

interface AuthStatusProps {
  status: AuthStatusType
  progress: number
  error?: string
}

function AuthStatusDisplay({ status, progress, error }: AuthStatusProps) {
  return (
    <div className="text-center mb-6">
      {status === 'waiting' && (
        <div>
          <p className="text-lg font-bold text-gray-900 mb-2">
            Waiting for YubiKey&reg;...
          </p>
          <p className="text-sm text-gray-600">
            Please insert your security key
          </p>
        </div>
      )}

      {status === 'touching' && (
        <div>
          <p className="text-lg font-bold text-yubico-green-500 mb-2 flex items-center justify-center gap-2">
            <i className="iconoir-fingerprint animate-pulse text-2xl"></i>
            Touch the sensor now
          </p>
          <p className="text-sm text-gray-600">
            Place your finger on the gold contact
          </p>
        </div>
      )}

      {status === 'verifying' && (
        <div>
          <p className="text-lg font-bold text-yubico-green-500 mb-2">
            Verifying credentials...
          </p>
          <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-yubico-green-400 to-yubico-green-500 transition-all duration-300 shimmer-effect"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      )}

      {status === 'success' && (
        <div>
          <p className="text-lg font-bold text-yubico-green-500 mb-2 flex items-center justify-center gap-2">
            <i className="iconoir-shield-check text-2xl"></i>
            Authentication Successful!
          </p>
          <p className="text-sm text-gray-600">
            Redirecting to your dashboard...
          </p>
        </div>
      )}

      {status === 'error' && (
        <div>
          <p className="text-lg font-bold text-red-500 mb-2 flex items-center justify-center gap-2">
            <i className="iconoir-warning-circle text-2xl"></i>
            Authentication Failed
          </p>
          <p className="text-sm text-gray-600">
            {error || 'An unexpected error occurred. Please try again.'}
          </p>
        </div>
      )}
    </div>
  )
}

export default AuthStatusDisplay
